// Briefly pulses an Upgrade CTA when a Free Customer tries to use paid functionality.
// Trigger from anywhere with: this.$root.$emit('upgrade-pulse')
export default {
  data () {
    return {
      pulsing: false
    }
  },

  mounted () {
    this.$root.$on('upgrade-pulse', this.pulseUpgrade)
  },

  beforeDestroy () {
    this.$root.$off('upgrade-pulse', this.pulseUpgrade)
    clearTimeout(this.pulseTimer)
  },

  methods: {
    pulseUpgrade () {
      this.pulsing = false
      clearTimeout(this.pulseTimer)
      this.$nextTick(() => {
        this.pulsing = true
        this.pulseTimer = setTimeout(() => (this.pulsing = false), 1800)
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/upgrade-pulse.js